// Module
var code = "<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M6 10L9 13L15 7\" fill=\"none\" stroke-opacity=\"0.9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;